const productComponent = document.querySelectorAll('.new-product');
if (window.innerWidth >= 768) {
    productComponent.forEach(productComponent => {
        const price = productComponent.querySelector('.right-price');
        const label = productComponent.querySelector('.right-price-label');
        price.style.transform = `translateX(${label.getBoundingClientRect().width + 2}px)`;
        productComponent.addEventListener('mouseenter', () => {
            price.style.transform = `translateX(0)`;
            productComponent.classList.add('hover');
        });
        productComponent.addEventListener('mouseleave', () => {
            price.style.transform = `translateX(${label.getBoundingClientRect().width + 2}px)`;
            productComponent.classList.remove('hover');
        });
    });
}